import './EmptyState.css';

interface EmptyStateProps {
  icon?: string;
  title: string;
  message?: string;
  action?: {
    label: string;
    onClick: () => void;
  };
  illustration?: React.ReactNode;
}

export default function EmptyState({
  icon,
  title,
  message,
  action,
  illustration,
}: EmptyStateProps) {
  return (
    <div className="empty-state" role="status" aria-live="polite">
      {illustration ? (
        <div className="empty-state-illustration">{illustration}</div>
      ) : icon ? (
        <div className="empty-state-icon" aria-hidden="true">
          {icon}
        </div>
      ) : null}
      <h3 className="empty-state-title">{title}</h3>
      {message && <p className="empty-state-message">{message}</p>}
      {action && (
        <button className="btn btn-primary empty-state-action" onClick={action.onClick}>
          {action.label}
        </button>
      )}
    </div>
  );
}

// Estados vacíos predefinidos comunes
export function EmptyStateNoData({ onCreate }: { onCreate?: () => void }) {
  return (
    <EmptyState
      icon="📦"
      title="No hay datos"
      message="Aún no se han registrado elementos. Comienza creando uno nuevo."
      action={onCreate ? { label: 'Crear nuevo', onClick: onCreate } : undefined}
    />
  );
}

export function EmptyStateNoResults({ onClearFilters }: { onClearFilters?: () => void }) {
  return (
    <EmptyState
      icon="🔍"
      title="No se encontraron resultados"
      message="Intenta ajustar los filtros de búsqueda para encontrar lo que buscas."
      action={onClearFilters ? { label: 'Limpiar filtros', onClick: onClearFilters } : undefined}
    />
  );
}

export function EmptyStateError({
  message = 'Ocurrió un error al cargar los datos.',
  onRetry,
  variant = 'error',
}: {
  message?: string;
  onRetry?: () => void;
  variant?: 'error' | 'warning' | 'info';
}) {
  return (
    <EmptyState
      icon="⚠️"
      title="Error al cargar"
      message={message}
      action={onRetry ? { label: 'Reintentar', onClick: onRetry } : undefined}
    />
  );
}

